import { render } from "./RequestFormComplete.vue?vue&type=template&id=124fa6f8"
import script from "./RequestFormComplete.vue?vue&type=script&lang=js"
export * from "./RequestFormComplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__